import styled from 'styled-components';
import { COLORS, newLayout } from '../../../../theme';

export const SettingsHeader = styled.div`
  padding: ${newLayout.spacing.s3} 0;
  font-size: ${newLayout.fontSize.body1};
  font-weight: bold;
`;

export const SettingsGroupContainer = styled.div`
  width: 100%;
`;

export const SettingsGroupItem = styled.div`
  padding: ${({ theme }) => theme.spacing.s2} ${({ theme }) => theme.spacing.s3};
  border: 1px solid ${COLORS.black06};
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  ${({ isDragging }) => isDragging && `background-color: ${COLORS.black06}`};
  margin-bottom: ${({ theme }) => theme.spacing.s1};
  display: flex;

  svg {
    margin-left: auto;
    path {
      fill: ${COLORS.black40};
    }
  }
`;
export const StyledTableSettingsContainer = styled.div``;

export const DialogHeader = styled.p`
  color: ${COLORS.kinetikBlack};
  font-size: ${({ theme }) => theme.fontSize.h4};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;
